var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none",
    viewBox: "0 0 70 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 47,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#DADADA",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M35.5 34.314a13.5 13.5 0 0 1-8.852 3.298C19.11 37.612 13 31.43 13 23.806S19.11 10 26.648 10c3.378 0 6.469 1.242 8.852 3.298A13.5 13.5 0 0 1 44.353 10C51.89 10 58 16.181 58 23.806s-6.11 13.806-13.647 13.806c-3.379 0-6.47-1.242-8.853-3.298",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M35.5 34.314a13.84 13.84 0 0 0 4.795-10.508A13.84 13.84 0 0 0 35.5 13.298 13.5 13.5 0 0 1 44.353 10C51.89 10 58 16.181 58 23.806s-6.11 13.806-13.647 13.806c-3.379 0-6.47-1.242-8.853-3.298",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M35.5 13.298a13.84 13.84 0 0 1 4.795 10.508c0 4.208-1.86 7.976-4.795 10.508a13.84 13.84 0 0 1-4.795-10.508c0-4.207 1.86-7.975 4.795-10.508",
    clipRule: "evenodd"
  })));
};
export default SvgMastercard;